module.exports = __webpack_public_path__ + "img/se.6c3446b8.svg";